import { Integration } from 'botpress-client'
import cx from 'classnames'
import { ComponentProps, Dispatch, SetStateAction } from 'react'
import { Checkbox } from '~/elements'

type BooleanSwitchProps = {
  booleanKey: string
  integration: Integration
  data: Record<string, any>
  setData: Dispatch<SetStateAction<Record<string, any>>>
} & ComponentProps<'div'>

// A Simple reusable switch for an integration configuration boolean
export function BooleanSwitch({ booleanKey, integration, data, setData, ...props }: BooleanSwitchProps) {
  return (
    <div className={cx('flex w-full items-center justify-start', props.className)}>
      <Checkbox
        label={integration?.configuration?.schema?.properties[booleanKey]?.title || booleanKey}
        checked={data[booleanKey]}
        onCheckedChange={() => {
          setData({ ...data, [booleanKey]: !data[booleanKey] })
        }}
      />
    </div>
  )
}
